import { useContext } from "react";

// global state
import { StateContext } from "../../AppStateContext";

import { useHistory } from "react-router-dom";

const SchemaDecisionMaker = ({ schema }) => {
  const state = useContext(StateContext);

  const history = useHistory();
  if (state.isWeaviateURIDisconnected) {
    history.push("/console/Schema/weaviate-not-connected");
    return null;
  } else if (schema && !schema.classes.length) {
    history.push("/console/Schema/new-schema");
    return null;
  } else if (schema && schema.classes.length !== 0) {
    history.push("/console/Schema/view-schema");
    return null;
  } else {
    return null;
  }
};

export default SchemaDecisionMaker;
